import { useCookies } from 'react-cookie'
import { useState } from 'react'

import { ROLES } from 'types/user'
import { useRouter } from 'next/router'

export type AdFreeTrialStatus = 'LOGGED_OUT' | 'NOT_STARTED' | 'IN_PROGRESS' | 'EXPIRED'

export const FREE_TRIAL_DEFAULT = '1990-01-01'

export const useAdFreeTrialStatus = (): [AdFreeTrialStatus, Date] => {
  const [{ tbId, tbFreeTrialExpiresAt = FREE_TRIAL_DEFAULT }] = useCookies(['tbId', 'tbFreeTrialExpiresAt'])
  const [now] = useState(new Date())
  const freeTrialExpiresDate = new Date(`${tbFreeTrialExpiresAt}`)

  if (!tbId) return ['LOGGED_OUT', freeTrialExpiresDate]
  // checking any default or falsey value. If any of these values are set, the user hasn't accepted the free trial
  if (['null', 'undefined', '', FREE_TRIAL_DEFAULT].includes(tbFreeTrialExpiresAt))
    return ['NOT_STARTED', freeTrialExpiresDate]
  if (now <= freeTrialExpiresDate) return ['IN_PROGRESS', freeTrialExpiresDate]

  return ['EXPIRED', freeTrialExpiresDate]
}

export const useAdFree = () => {
  const router = useRouter()

  const [{ tbTier: tier, tbR: roles = [], loadedWithCustomCards }] = useCookies(['tbTier', 'tbR', 'loadedWithCustomCards'])
  const [adFreeTrialStatus] = useAdFreeTrialStatus()

  const hidesAds = roles.includes(ROLES.AD_FREE) || Number(tier) || adFreeTrialStatus === 'IN_PROGRESS' || (loadedWithCustomCards === 'true' && (router.route.startsWith('/decks/') || router.route.startsWith('/sandbox/'))) 

  return hidesAds
}

export const useModerator = () => {
  const [{ tbR: roles = [] }] = useCookies(['tbId', 'tbR'])

  const isModerator = roles.includes(ROLES.MOD)

  return isModerator
}
